
import Vue from 'vue';
import EuCard from '../Card/Card.vue';
import EuCheckbox from '../Checkbox/Checkbox.vue';
import ArrowDown from '../../../Icons/ArrowLightCircular.vue';
/**
- The content inside expanded card is slot based, not with props, therefore it's customizable. Check the story source below to see how to use.
**/
export default Vue.extend<any, any, any, any>({
  name: 'CollapsibleCard',
  components: {
    EuCard,
    EuCheckbox,
    ArrowDown
  },
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set Title text
     */
    cardTitle: {
      type: String,
      default: ''
    },
    /**
     * Set Title description text
     */
    cardTitleDescription: {
      type: String,
      default: ''
    },
    /**
     * Set Subtitle text
     */
    cardSubtitle: {
      type: String,
      default: ''
    },
    /**
     * Set circle color in arrow icon
     */
    circleFill: {
      type: String
    },
    /**
     * Set arrow color
     */
    arrowFill: {
      type: String
    },
    /**
     * Set card elevation
     */
    elevation: {
      type: String
    },
    /**
     * Set checkbox selected
     */
    selected: {
      type: Boolean,
      default: undefined
    },
    /**
     * Set checkbox on disabled
     */
    checkboxDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      expand: false
    };
  },
  computed: {
    computedArrow() {
      if (this.expand) {
        return `transform: rotate(180deg)`;
      }
      return ``;
    },
    isWithCheckbox() {
      return this.selected != undefined;
    }
  },
  methods: {
    handleSelect(e: any) {
      /**
       * Handle checkbox value
       * @event check
       * @type {function}
       */
      this.$emit('check', e);
    },
    handleClick(e: any) {
      this.expand = !this.expand;
      /**
       * Method to click to expand below content
       * @event click-expand
       * @type {function}
       */
      this.$emit('click-expand', e);
    }
  }
});
